var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMedalBadge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.334 1.333h3.75l2.25 3.375A5.396 5.396 0 004.444 6l-3.11-4.667zm13.333 0l-3.11 4.665a5.395 5.395 0 00-2.89-1.292l2.25-3.373h3.75zm-11.25 8.75a4.583 4.583 0 119.167 0 4.583 4.583 0 01-9.167 0zm4.584-2.5l-.774 1.49-1.726.237 1.25 1.159-.295 1.635 1.545-.77 1.544.773-.294-1.638L10.5 9.31l-1.727-.24-.773-1.487z",
    fill: "#FF7342"
  })));
}

export default SvgMedalBadge;